import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/ListaVenta`

export function buscarListaPorVendedor(idVendedor) {
  return http.get(`${API_ENDPOINT}/BuscarPorVendedor/${idVendedor}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las listas de venta.',
      tipoError: 'listaVenta'
    }
  })
}

export function insertarLista(listaVenta) {
  return http.post(API_ENDPOINT, listaVenta)
}

export function actualizar(listaModificada) {
  return http.put(API_ENDPOINT, listaModificada)
}

export function actualizarDescuentoLista(data) {
  return http.put(`${API_ENDPOINT}/ActualizarDescuentoLista`, data)
}
